import { render, staticRenderFns } from "./LearningLessonsPage.vue?vue&type=template&id=44a5ab6e&scoped=true&"
import script from "./LearningLessonsPage.vue?vue&type=script&lang=ts&"
export * from "./LearningLessonsPage.vue?vue&type=script&lang=ts&"
import style0 from "./LearningLessonsPage.vue?vue&type=style&index=0&id=44a5ab6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a5ab6e",
  null
  
)

export default component.exports